import { render, staticRenderFns } from "./IconRefresh.vue?vue&type=template&id=3092f97c&"
import script from "./IconRefresh.vue?vue&type=script&lang=ts&"
export * from "./IconRefresh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports